/* !
 * biennale.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {
	const a = 'is-active';
	const v = 'is-visible';
	// const _pagepath = '/contribution/biennale/';
	const dropDown = () => {
		if(document.querySelector('.js-news-yearList')) {
			// 最新と最古の年を取得
			const latest = document.querySelector('.js-news-latest-year').textContent;
			const earliest = document.querySelector('.js-news-earliest-year').textContent;
			// ドロップダウンリスト要素を取得
			const yearList = document.querySelector('.js-news-yearList');
			const optionVal = (_num) => {
				if(location.pathname.replace('index.html','') == _pagepath) {
					return _pagepath+_num+`/`;
				} else {
					if(location.pathname.match(/\d{4}/)){
						// 文字列に正規表現4桁数値が含まれていたら
						return location.pathname.replace(location.pathname.match(/\d{4}/)[0], _num);
					}
				}
			};
			// 最新から最古の年までのオプションを生成し追加
			for(var i =latest; i>=earliest; i--) {
				const option = document.createElement('option');
				option.textContent = i.toString();
				option.value = optionVal(i);
				document.querySelector('.js-news-yearList').appendChild(option);
			}
			// ドロップダウンリストで選択された年を設定
			yearList.value = location.pathname;
			
			// ドロップダウンリストの変更イベントを処理(プルダウンの場合)
			document.querySelector('.js-news-yearList').addEventListener('change', function() {
				location.href = yearList.value;
			});
		}
	};

	const biennaleNewsList = () => {
	    // json定義
	    const getJSONfiles = () => {
	        return `/ajax/news/biennale.json`;
	    };

	    // json出力・イベント
	    fetch(getJSONfiles()).then(function (response) {
	        return response.json();
	    }).then(function (data) {
	        // console.log(data, 'JSON data');
	        const bytesToSize = (bytes) => {
	            var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
	            if (bytes === 0) {
	                return 'n/a';
	            }
	            var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
	            if (i === 0) {
	                return bytes + ' ' + sizes[i];
	            }
	            return (bytes / Math.pow(1024, i)).toFixed(1) + ' ' + sizes[i];
	        }
	        if (data.rt_bn_news_list.length) {
	            let groupedData = {};

	            // データを年度ごとにグループ化
	            data.rt_bn_news_list.forEach(function (val) {
	                let year = new Date(val.cf_n_date).getFullYear();
	                if (!groupedData[year]) {
	                    groupedData[year] = [];
	                }
	                groupedData[year].push(val);
	            });

	            let HTML = '';

	            // グループ化したデータを年度の降順でHTMLに変換
	            Object.keys(groupedData).sort((a, b) => b - a).forEach(function (year) {
	                let yearHTML = `<div class="mod-spacer_50">
	                                <div class="mod-auto">
	                                    <h3 class="mod-head03 __border"><span>${year}年度</span></h3>
	                                    <ul class="news-list mod-spacer_30">`;

	                let yearContent = '';

	                groupedData[year].forEach(function (val) {
	                    // リンクを設定
	                    let link = '';
	                    let linkAttributes = '';

	                    if (val.cf_n_type === 1 && val.cf_n_category.cf_nc_group_code === 'newsreleases') {
	                        link = `/news/detail/${val._key}.html`;
	                    } else if (val.cf_n_type === 1 && val.cf_n_category.cf_nc_group_code === 'biennial-exhibition') {
	                        link = `/contribution/biennale/detail/${val._key}.html`;
	                    } else if (val.cf_n_type === 2) {
	                        link = `/news/news_file/file/${val.cf_n_attachment_file_jp}`;
	                        linkAttributes = 'class="mod-link_text __pdf"';
	                    } else if (val.cf_n_type === 3) {
	                        if (/^https?:\/\//.test(val.cf_n_url_jp)) {
	                            linkAttributes = 'target="_blank"';
	                        } else {
	                            linkAttributes = 'target="_self"';
	                        }
	                        link = val.cf_n_url_jp;
	                    } else if (val.cf_n_type === 5) {
	                        linkAttributes = 'style="pointer-events:none; cursor:default; text-decoration:none;" class="rt_cf_nolink"';
	                        link = '#';
	                    } else {
	                        link = '#'; // 他の場合、ダミーリンクを設定
	                    }

	                    // 現在のページのURLに「/eng/」または「/cn/」が含まれている場合にリンクを修正
	                    if (window.location.href.includes('/eng/')) {
	                        link = `/eng${link}`;
	                    } else if (window.location.href.includes('/cn/')) {
	                        link = `/cn${link}`;
	                    }

	                    // 現在のページのURLに「/eng/」または「/cn/」が含まれている場合に名称とタイトルを修正
	                    let categoryName = val.cf_n_category.cf_nc_name;
	                    let title = val.cf_n_title_jp;
	                    if (window.location.href.includes('/eng/')) {
	                        categoryName = val.cf_n_category.cf_nc_name_en;
	                        title = val.cf_n_title_en;
	                    } else if (window.location.href.includes('/cn/')) {
	                        categoryName = val.cf_n_category.cf_nc_name_cn;
	                        title = val.cf_n_title_cn;
	                    }

	                    // 日付を指定された形式にフォーマット
	                    let date = new Date(val.cf_n_date);
	                    let formattedDate = `${date.getFullYear()}年${(date.getMonth() + 1).toString().padStart(2, '0')}月${date.getDate().toString().padStart(2, '0')}日`;

	                    let newsItemHTML = `<li class="news-list-item">
	                                        <div class="news-list-item-data">
	                                            <p class="news-list-item_txt-day">${formattedDate}</p>
	                                            <p class="news-label">${categoryName}</p>
	                                        </div>`;

	                    // cf_n_typeが2の場合のHTMLを生成
	                    if (val.cf_n_type === 2) {
	                        newsItemHTML += `<a target="_blank" ${linkAttributes} href="${link}">
	                                            <span>${title}</span>
	                                            <svg aria-hidden="true" class="_icon">
	                                                <use xlink:href="/common/svg/sprite.svg#pdf" />
	                                            </svg>
	                                            <span class="_fileSize">（<span class="js-fileSize">${bytesToSize(val.cf_n_attachment_file_size_jp)}</span>）</span>
	                                        </a>`;
	                    } else {
	                        // cf_n_typeが2以外の場合のHTMLを生成
	                        newsItemHTML += `<a class="mod-link_text" ${linkAttributes} href="${link}">
	                                            <span>${title}</span>
	                                        </a>`;
	                    }

	                    newsItemHTML += `</li>`;

	                    yearContent += newsItemHTML;
	                });

	                yearHTML += yearContent;
	                yearHTML += `</ul>
	                            </div>
	                        </div>`;

	                // .news-list が空でない場合のみ追加
	                if (yearContent.trim() !== '') {
	                    HTML += yearHTML;
	                }
	            });

				const contributionList = document.querySelector('.js-contributionList');
				if (contributionList) {
	            	contributionList.insertAdjacentHTML('beforeend', HTML);
	            }

	            // spanが空の場合、該当する.news-list-item要素を削除
	            document.querySelectorAll('.mod-link_text span').forEach(span => {
	                if (span.textContent.trim() === '') {
	                    span.closest('.news-list-item').remove();
	                }
	            });

	            // .news-list が空の場合、その親要素を削除
	            document.querySelectorAll('.news-list').forEach(newsList => {
	                if (newsList.innerHTML.trim() === '') {
	                    newsList.closest('.mod-spacer_50').remove();
	                }
	            });
	        }
	    });
	}




	dropDown();
	biennaleNewsList();


})(window.FUNCTIONS);
